export const GopherChartConfig = {
    lineTension: 1,
    fill: false,
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            },
            scaleLabel: {
                display: true,
                labelString: 'Usage',
            }
        }],
        xAxes: [{
            scaleLabel: {
                display: true,
                labelString: 'Start time',
            }
        }]
    },
    tooltips: {
        bodyFontSize: 10
    }
};
